import { TextField } from "@mui/material";
import React, { useState } from "react";

export const Edad = (props) => {
    
    const onTrigger = (event) => {
        
        (event.target.value < 2) ? setOnError(true) : setOnError(false);

        props.parentCallback(event);
    };

    const [OnError, setOnError] = useState(false);

    return (
        <TextField
            defaultValue={props.value}
            error={OnError}
            fullWidth
            id={props.name}
            label={props.label}
            name={props.name}
            onChange={onTrigger}
            required={props.required}
            size="small"
            type="number"
            variant={props.variant}
        />
    );
};
